import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class OringRecommendationService {
  private OringRecommendation;
  private OringRecommendationJis;
  constructor(private http: HttpClient) {}

  private OringRecommendationData() {
    this.OringRecommendation = this.http.get('assets/calculations-json/Oring recommendation .json');
  }

  private OringRecommendationJisData() {
    this.OringRecommendationJis = this.http.get('assets/calculations-json/Oring recommendation_jis.json');
  }

  getOringRecommendation() {
    if (!this.OringRecommendation) {
      this.OringRecommendationData();
    }
    return this.OringRecommendation;
  }

  getOringRecommendationJis() {
    if (!this.OringRecommendationJis) {
      this.OringRecommendationJisData();
    }
    return this.OringRecommendationJis;
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/service/OringRecommendationService.ts